/**
 * Strips HTML tags from a string, returning clean text
 * @param {string} htmlString - String that may contain HTML tags
 * @returns {string} - String with HTML tags removed, or original if falsy
 */
const stripHtmlTags = (htmlString) => {
  if (!htmlString) return htmlString
  return htmlString.replace(/(<([^>]+)>)/gi, '')
}

export default stripHtmlTags
